/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TrackItMeasurementPropertyDto } from './TrackItMeasurementPropertyDto';
import {
    instanceOfTrackItMeasurementPropertyDto,
    TrackItMeasurementPropertyDtoFromJSON,
    TrackItMeasurementPropertyDtoFromJSONTyped,
    TrackItMeasurementPropertyDtoToJSON,
} from './TrackItMeasurementPropertyDto';

/**
 * @type TrackItMeasurementPropertyFilterDtoMeasurementProperty
 * 
 * @export
 */
export type TrackItMeasurementPropertyFilterDtoMeasurementProperty = TrackItMeasurementPropertyDto;


export function TrackItMeasurementPropertyFilterDtoMeasurementPropertyFromJSON(json: any): TrackItMeasurementPropertyFilterDtoMeasurementProperty {
    return TrackItMeasurementPropertyFilterDtoMeasurementPropertyFromJSONTyped(json, false);
}

export function TrackItMeasurementPropertyFilterDtoMeasurementPropertyFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItMeasurementPropertyFilterDtoMeasurementProperty {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...TrackItMeasurementPropertyDtoFromJSONTyped(json, true) };
    return  TrackItMeasurementPropertyDtoFromJSONTyped(json, true);
}

export function TrackItMeasurementPropertyFilterDtoMeasurementPropertyToJSON(value?: TrackItMeasurementPropertyFilterDtoMeasurementProperty | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfTrackItMeasurementPropertyDto(value)) {
        return TrackItMeasurementPropertyDtoToJSON(value as TrackItMeasurementPropertyDto);
    }

    return {};
}

/**
 * Check if a given object implements the TrackItMeasurementPropertyFilterDtoMeasurementProperty interface.
 */
export function instanceOfTrackItMeasurementPropertyFilterDtoMeasurementProperty(value: any): value is TrackItMeasurementPropertyFilterDtoMeasurementProperty {
    if (instanceOfTrackItMeasurementPropertyDto(value)) return true;
    return false;
}

